import { EOutcomingStatus, TMessageSchema, TOutcomingStatus, IParsedMessage } from '../../types/messages';
import { getTimePage, getTimePageKey } from './getTimePage';
import { isMessageDeleted } from './isMessageDeleted';
import { isMessageOutcoming } from './isMessageOutcoming';
import { isMessageRead } from './isMessageRead';

interface IParseMessageParams {
  rawMessage: TMessageSchema;
  userId: number;
  status?: TOutcomingStatus;
}

/**
 * @description
 * Парсит сообщение с бэкенда в сообщение для UI
 */
export function parseMessage({ rawMessage, userId, status }: IParseMessageParams): IParsedMessage {
  const {
    assumptions,
    bubbles,
    actionButtons,
    actionButtonsV3,
    chatId,
    communicationId,
    files,
    fromChatBot,
    fromCrm,
    htmlText,
    images,
    messageId,
    offers,
    rowVersion,
    text,
    type,
    uid,
    userId: messageUserId,
    created,
    reply,
  } = rawMessage;

  const isOutcoming = isMessageOutcoming({ rawMessage, userId });

  const isRead = isMessageRead({ rawMessage, isOutcoming });
  const readStatusFields = isOutcoming
    ? { status: isRead ? EOutcomingStatus.Read : status || EOutcomingStatus.Fulfilled }
    : { isRead, status: undefined };

  const timePage = getTimePage(created);

  return {
    messageId,
    uid: uid || messageId,
    chatId,
    timePage,
    timePageKey: getTimePageKey(timePage),
    rawMessage,
    message: {
      actionButtons,
      actionButtonsV3,
      assumptions,
      bubbles,
      communicationId,
      created: new Date(created).getTime(),
      files,
      fromChatBot,
      fromCrm,
      htmlText,
      images,
      isOutcoming,
      message: text || '',
      offers,
      rowVersion,
      type,
      userId: messageUserId,
      isDeleted: isMessageDeleted(rawMessage),
      reply,
      ...readStatusFields,
    },
  };
}
